import { type IOverviewJointBillService } from "@services/overview/types";
import { api } from "@/api";
import type {
  IJointBillServiceSettings,
  IJointBillServiceSettingsRequest,
  IProjectData,
  ISubmitDiscountCodeRequest,
  ISubmitEmailSubscriptionStateRequest,
  ISubmitPaperBillDeliveryStateRequest,
} from "./types";

export const getJointBillServiceSettings = async (
  data: IJointBillServiceSettingsRequest,
): Promise<IJointBillServiceSettings> =>
  (
    await api.get<IJointBillServiceSettings>("/joint-bill-services/settings", {
      headers: { jointBillServiceId: data.jointBillServiceId },
    })
  ).data;

export const submitJointBillServiceDiscountCode = async (
  data: ISubmitDiscountCodeRequest,
) => {
  await api.put(
    `/joint-bill-services/discount-codes`,
    { discountCode: data.discountCode },
    {
      headers: { jointBillServiceId: data.jointBillServiceId },
    },
  );
};

export const updateJointBillServicePaperBillDeliveryState = async (
  data: ISubmitPaperBillDeliveryStateRequest,
) => {
  return await api.put(
    `/joint-bill-services/paper-bill-delivery`,
    { newPaperBillDeliveryState: data.newPaperBillDeliveryState },
    {
      headers: { jointBillServiceId: data.jointBillServiceId },
    },
  );
};

export const updateJointBillServiceEmailSubscriptionState = async (
  data: ISubmitEmailSubscriptionStateRequest,
) => {
  return await api.put(
    `/joint-bill-services/subscriptions/emails`,
    { newEmailSubscriptionState: data.newEmailSubscriptionState },
    {
      headers: { jointBillServiceId: data.jointBillServiceId },
    },
  );
};

export const updateJointBillServiceProjectMailDeliverySettings = async ({
  jointBillServiceId,
  serviceProviderId,
  isChecked,
}: {
  jointBillServiceId: number;
  serviceProviderId: number;
  isChecked: boolean;
}) =>
  await api.put(
    "/joint-bill-services/projects/bill-deliveries/mail",
    {
      serviceProviderId,
      isChecked,
    },
    { headers: { jointBillServiceId } },
  );

export const updateJointBillServiceSmsSubscription = (
  data: { isActive: boolean; phoneNumber: string },
  jointBillServiceId: IOverviewJointBillService["jointBillServiceId"],
) =>
  api.put<void>(`/joint-bill-services/subscriptions/sms`, data, {
    headers: { jointBillServiceId },
  });

export const getProjectData = (
  jointBillServiceId: IOverviewJointBillService["jointBillServiceId"],
) =>
  api
    .get<IProjectData>("/joint-bill-services/contacts", {
      headers: { jointBillServiceId },
    })
    .then((r) => r.data);

export const updateProjectData = (
  data: IProjectData,
  jointBillServiceId: IOverviewJointBillService["jointBillServiceId"],
) =>
  api.put("/joint-bill-services/contacts", data, {
    headers: { jointBillServiceId },
  });

export const deleteProjectData = (
  jointBillServiceId: IOverviewJointBillService["jointBillServiceId"],
) =>
  api.delete("/joint-bill-services/contacts", {
    headers: { jointBillServiceId },
  });
